var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.317,2.088c-1.068-.892-2.466-1.262-3.837-1.012l-3.995.727c-1.073.195-1.964.849-2.485,1.736-.521-.888-1.412-1.541-2.486-1.736l-3.995-.727c-1.37-.248-2.768.12-3.837,1.012-1.069.893-1.682,2.202-1.682,3.595v11.374c0,2.263,1.617,4.2,3.844,4.606l6.57,1.194c.526.096,1.056.144,1.585.144s1.06-.048,1.586-.144l6.57-1.194c2.228-.406,3.844-2.344,3.844-4.606V5.683c0-1.392-.613-2.702-1.683-3.595Zm-10.817,19.896c-.303-.02-.605-.057-.907-.111l-6.57-1.194c-1.752-.319-3.023-1.843-3.023-3.622V5.683c0-1.095.482-2.125,1.323-2.827.668-.558,1.501-.855,2.355-.855.22,0,.441.021.662.061l3.995.727c1.254.229,2.165,1.319,2.165,2.594v16.604Zm11.5-4.928c0,1.779-1.271,3.303-3.023,3.622l-6.569,1.194c-.302.055-.604.092-.907.111V5.381c0-1.274.91-2.365,2.165-2.594l3.995-.727c1.074-.195,2.177.094,3.017.796.841.701,1.323,1.731,1.323,2.826v11.374Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.b54813487e03d96dbe195c8a50f5ffb4.svg";
export { ForwardRef as ReactComponent };